import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AboutUsPage } from './Misc.AboutUs/AboutUsPage';
import { Error404Page } from './Misc.Errors.404/Error404Page';
import { TermsPage } from './Misc.Terms/TermsPage';
import { ProjectsListPage } from './Projects.List/ProjectsListPage';
import {
  ProjectsRolesPage,
  ProjectsEmployeesPage,
  ProjectsEpicsPage,
  ProjectsEpicGroupsPage,
  ProjectsColumnsPage,
  ProjectsTablesPage,
  ProjectsSheetsPage,
} from './Projects.Constructor';
import { tabNames } from '@/views';

const ProjectPage = lazy(() => import('./Projects.Project/ProjectPage'));
const ProjectsConstructorPage = lazy(() => import('./Projects.Constructor/ProjectsConstructorPage'));
const UserDetailsPage = lazy(() => import('./Users.Details/UserDetailsPage'));
const UserChangePasswordPage = lazy(() => import('./Users.ChangePassword/UserChangePasswordPage'));
const UsersListPage = lazy(() => import('./Users.List/UsersListPage'));
const UserProfilePage = lazy(() => import('./Users.Profile/UserProfilePage'));

export function Pages() {
  return (
    <Routes>
      <Route path="/terms-and-conditions" element={<TermsPage />} />
      <Route path="/about-us" element={<AboutUsPage />} />
      <Route path="/me" element={<UserProfilePage />} />
      <Route path="/change-password" element={<UserChangePasswordPage />} />
      <Route path="/users" element={<UsersListPage />} />
      <Route path="/users/:id" element={<UserDetailsPage />} />
      <Route path="/projects" element={<ProjectsListPage />} />
      <Route path="/projects/constructor/:id" element={<ProjectsConstructorPage />}>
        <Route path="" element={<Navigate to={tabNames.positions} />} />
        <Route path={tabNames.positions} element={<ProjectsRolesPage />} />
        <Route path={tabNames.employees} element={<ProjectsEmployeesPage />} />
        <Route path={tabNames.epics} element={<ProjectsEpicsPage />} />
        <Route path={tabNames.epicGroups} element={<ProjectsEpicGroupsPage />} />
        <Route path={tabNames.columns} element={<ProjectsColumnsPage />} />
        <Route path={tabNames.tables} element={<ProjectsTablesPage />} />
        <Route path={tabNames.sheets} element={<ProjectsSheetsPage />} />
      </Route>
      <Route path="/projects/project/:id" element={<ProjectPage />} />
      <Route path="*" element={<Error404Page />} />
      <Route path="/" element={<Navigate to="/projects" />} />
    </Routes>
  );
}
